import { render } from "./HotDealShelf.vue?vue&type=template&id=7a3e6f5a&scoped=true"
import script from "./HotDealShelf.vue?vue&type=script&lang=js"
export * from "./HotDealShelf.vue?vue&type=script&lang=js"

import "./HotDealShelf.vue?vue&type=style&index=0&id=7a3e6f5a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a3e6f5a"]])

export default __exports__